(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gemist-designer"] && !Shopify.designMode) return;
  try {
    

  const baseURL = "http://happyjewelers.gemist.co/";

  window.onload = function() {

// Get the current URL of the parent page
    var url = window.location.href;

// Get the query string from the URL
    var queryString = url.split('?')[1];

// Create the iframe URL with the query string
    var iframeUrl = baseURL + "designer/engagement?" + queryString;

// Set the iframe's source URL
    var iframe = document.getElementById("designer-iframe");

    iframe.src = iframeUrl;
  };

  window.addEventListener("message", function(event) {

    const designerIframe = document.getElementById("designer-iframe");

    if (event.data) {
      try {
        const message = JSON.parse(event.data);
        switch (message.type) {
                    case "buy":
                    console.log(message);
                      var id = message.product.Shopify.productVariant
                        .split("/")
                        .slice(-1)[0];
                      var size = message.size;

                      const items = [];
          
                      let product = {
                        id: id,
                        quantity: 1,
                        properties: {
                          Size: size,
                          _disable_click: true,
                        },
                      };

                      if (message.engravingTextRing != "") {
                        let engraving = {
                          id: "47241281175778",
                          quantity: 1,
                          properties: {
                            "Text": message.engravingTextRing.toUpperCase(),
                            _variant_id: id,
                            _disable_click: true,
                          }
                        };

                        product.properties.Engraving = message.engravingTextRing.toUpperCase();

                        items.push(engraving);
                      }
                    
                      if (message.matchingBand) {
                        let matchingBand = {
                          id: message.matchingBand.Shopify.productVariant
                        .split("/")
                        .slice(-1)[0],
                          quantity: 1,
                          properties: {
                            _disable_click: true,
                          }
                        };

                        if (message.engravingRingBand != "") {
                          let engravingRingBand = {
                            id: "47241277931746",
                            quantity: 1,
                            properties: {
                              "Text": message.engravingRingBand.toUpperCase(),
                              _variant_id: matchingBand.id,
                              _disable_click: true,
                            }
                          };
  
                          matchingBand.properties.Engraving = message.engravingRingBand.toUpperCase();
  
                          items.push(engravingRingBand);
                        }
                        
                        items.push(matchingBand);
                      }

                      items.push(product);
          
                      if (message.diamond.variantId !== undefined) {
                        let diamond = {
                          id: message.diamond.variantId.split("/").slice(-1)[0],
                          quantity: 1,
                        };
                        items.push(diamond);
                      }

                      cart = window.cart || 
                        document.querySelector("cart-notification") ||
                        document.querySelector("cart-drawer");
          
                      fetch(window.Shopify.routes.root + 'cart/add.js', {
                        method: "POST",
                        headers: {
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ items: items }),
                      })
                        .then((response) => {
                          if (cart && typeof cart.getCart === 'function') {
                            cart.getCart();
                          }
                          var event = new Event('cart:refresh');
                          document.dispatchEvent(event);
                          
                          fetch("/cart.js")
                            .then((response) => response.json())
                            .then((cart) => {
                              const count = cart.item_count;

                              document.querySelectorAll("cart-count, .count, [data-cart-count], .cart-count").forEach((el) => {
                                el.textContent = count;
                                el.innerHTML = count;
                                el.setAttribute("aria-label", `${count} items`);

                                if (count > 0) {
                                  el.removeAttribute("hidden");
                                  el.style.display = "";
                                } else {
                                  el.setAttribute("hidden", "");
                                }
                              });

                              (
                                document.querySelector(".cart-drawer-button") ||
                                document.querySelector('[aria-controls="CartDrawer"]')
                              )?.click();
                            });
                        })
                        .catch((error) => {
                          console.error("Error:", error);
                        });

                      break;
                    case 'favorite':
                        var {id} = message.product;
                    
                        fetch(baseURL + 'api/products/' + id + '/shmetadata')
                        .then(response => response.json())
                        .then(data => {
                          var {productId, handle} = data;
                          
                          // create element to save
                          var elementToSave = document.createElement('div');
                          elementToSave.dataset.id = productId.split('/').slice(-1)[0];
                          elementToSave.dataset.handle = handle;
                          
                          // use the saveWishlist function that we made available from theme.js
                          saveWishlist($(elementToSave));
                        })
                        .catch((error) => {
							console.error('Error:', error);
						});
                        break;
                    case 'updateParams':
                        // Get the parameter names from the message
                        var paramNames = message.paramNames;
                        var currentURL = new URL(window.location.href);
                  
                        // Loop through the parameter names
                        paramNames.forEach(function(paramName) {
                          // Retrieve the corresponding value from the message
                          var paramValue = message[paramName];
                  
                          // Modify the query parameter of the parent URL with the value
                          if (paramValue !== undefined) {
                            currentURL.searchParams.set(paramName, paramValue);
                          }
                        });
                  
                        // Replace the parent URL with the modified URL
                        window.history.replaceState({}, "", currentURL.toString());
                        break;
          case 'download':
            const downloadHref = message.downloadHref;
            if (downloadHref) {
              window.open(downloadHref, "_blank");
            }
						break;
                    case 'copywindowlocation':
                        // Get the current window location
                        var windowLocation = window.location.href;
                        
                        // Use the Clipboard API to copy the window location to the clipboard
                        navigator.clipboard.writeText(windowLocation)
                          .then(function() {
                            console.log("Window location copied to clipboard successfully");
                          })
                          .catch(function(error) {
                            console.error("Failed to copy window location to clipboard:", error);
                          });
						break;
                     case 'sendemail':
                        let {emailContent, subject, recipient} = message;
                        const currentPageLink = window.location.href;
                        emailContent = emailContent.replace("{{currentPageLink}}", currentPageLink);                   

                        const mailtoLink = `mailto:${recipient}?subject=${encodeURIComponent(
                          subject
                        )}&body=${encodeURIComponent(emailContent)}`;

                        if (mailtoLink) {
                          window.open(mailtoLink, "_blank");
                        }
						break;
                    case "requestfullscreen":
                        void designerIframe.requestFullscreen();
                        break;
					default: 
						break;
        }
      } catch (e) { // console.log("Designer error", e);
      }
    }
  }, false);


// This function sets the Designer's iframe's height by calculating the imperative elements (navbar, announcement bar) height,
// then subtracting their pixel values from the viewport's fullscreen space.
  document.addEventListener("DOMContentLoaded", function() {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    const designerIFrameContainerElement = document.querySelector(".designer-iframe-container");
    const designerIFrameElement = document.querySelector("#designer-iframe");

    const selectorsToObserve = ["header"];
    const observedElements = document.querySelectorAll(selectorsToObserve.join(', '));

    const observer = new ResizeObserver(function(entries) {
      const totalHeight = entries.reduce((acc, entry) => acc + entry.contentRect.height, 20);

      if (designerIFrameContainerElement !== null && designerIFrameElement !== null && totalHeight) {
        const heightValueString = isMobileDevice
          ? `calc(100dvh - ${totalHeight}px)`
          : `calc(100vh - ${totalHeight}px)`;

        designerIFrameContainerElement.style.height = heightValueString;
        designerIFrameElement.style.height = heightValueString;
      }
    });
    observedElements.forEach(element => observer.observe(element));
  });


  } catch(e) { console.error(e); }
})();
})();
